import React from 'react';
import { AlertTriangle, CheckCircle, XCircle, Loader } from 'lucide-react';

interface ValidationPanelProps {
  errors: string[];
  isValidating: boolean;
}

const ValidationPanel: React.FC<ValidationPanelProps> = ({ errors, isValidating }) => {
  if (isValidating) {
    return (
      <div className="bg-primary-50 border border-primary-200 rounded-lg p-4">
        <div className="flex items-center space-x-2">
          <Loader className="w-5 h-5 text-primary-600 animate-spin" />
          <span className="text-sm font-medium text-blue-800">
            Validating orchestration...
          </span>
        </div>
      </div>
    );
  }

  if (errors.length === 0) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center space-x-2">
          <CheckCircle className="w-5 h-5 text-green-600" />
          <span className="text-sm font-medium text-green-800">
            Workflow is valid
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
      <div className="flex items-start space-x-2">
        <XCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="text-sm font-medium text-red-800 mb-2">
            Validation Errors ({errors.length})
          </h3>
          <ul className="space-y-1">
            {errors.map((error, index) => (
              <li key={index} className="text-sm text-red-700 dark:text-red-400 flex items-start space-x-2">
                <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>{error}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ValidationPanel;